import { IServedClientsIn } from "../../models/input/generalApi/IServedClientsIn";
import * as ApiWithToken from "../callApiWithToken";


const servedClientsService = {
    getWinRate:async function(appointmentActivityId:number, languageId:number){
        return ApiWithToken.getApi(process.env.REACT_APP_AGENDAS_API + `WinRate/GetWinRate?appointmentActivityID=${appointmentActivityId}&languageID=${languageId}`);
    },
    getWinRateCategories:async function(languageId:number){
        return ApiWithToken.getApi(process.env.REACT_APP_AGENDAS_API + `WinRate/GetWinRateCategories?languageID=${languageId}`);
    },
    insertServedClients:async function(servedClientIn: IServedClientsIn){
        return ApiWithToken.postApi(process.env.REACT_APP_AGENDAS_API + `WinRate/InsertWinRate`, servedClientIn);
    }
}
export default servedClientsService;
